import { render, staticRenderFns } from "./taskAssignment.vue?vue&type=template&id=608debb9&scoped=true"
import script from "./taskAssignment.vue?vue&type=script&lang=js"
export * from "./taskAssignment.vue?vue&type=script&lang=js"
import style0 from "./taskAssignment.vue?vue&type=style&index=0&id=608debb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608debb9",
  null
  
)

export default component.exports